"use client";
import Button from "@/components/atom/Button";
import Input from "@/components/atom/Input";
import currency from "@/functions/currency";
import { topUpBilling } from "@/functions/databaseData";
import fetchAPI from "@/functions/fetchAPI";
import useHeader from "@/functions/useHeader";
import useModal from "@/functions/useModal";
import {
  ChevronDownSvg,
  ChevronUpSvg,
  RadioCheckedSvg,
  RadioUncheckSvg
} from "@/public/svg";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { toast } from "react-toastify";

const settingToast = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

export default function Topup() {
  const { session } = useHeader();
  const { closeModal } = useModal();
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [chooseBank, setChooseBank] = useState(false);
  const [showBank, setShowBank] = useState({
    0: false
  });

  const { data: listBank } = useQuery({
    queryFn: async () => {
      const datas = await fetchAPI({
        uri: "payment/list/bank",
        method: "GET",
        token: session?.user?.token
      });
      if (!datas?.error) return datas.data;
      return [];
    },
    queryKey: ["list_bank"],
    refetchOnWindowFocus: false
  });

  async function handleTopUp() {
    setLoading(true);
    try {
      const isAmount = Number(amount?.replace(/[^0-9]/g, "") || 0);
      if (!isAmount) throw new Error("Masukkan nominal topup terlebih dahulu");
      if (isAmount < 10000 || isAmount <= 0)
        throw new Error(`Minimal topup ${currency(10000)}`);
      if (!chooseBank?.bank_code)
        throw new Error("Pilih metode pembayaran terlebih dahulu");

      const res = await topUpBilling({
        token: session?.user?.token,
        mitra_id: session.user.data.mitra_id, // didapat dari api profile
        amount: isAmount, // must be greater than or equal to 10000
        bank_code: chooseBank?.bank_code,
        type: chooseBank?.type,
        bank_name: chooseBank?.bank_name
      });

      if (res?.status == "success") {
        console.log(res);
        if (!res?.error) return (window.location.href = res?.data?.respon_url);
      }
      throw new Error(res?.error?.message);
    } catch (error) {
      toast.error(error.message, settingToast);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <p className="subheading-semiBold text-greyscaleGON-700">
          Topup Wallet
        </p>
      </div>
      <div id="nominal-topup" className="flex flex-col gap-2">
        <Input
          label={"Nominal Topup"}
          onChange={(a) => setAmount(a)}
          value={amount <= 0 ? "" : amount}
          placeholder={currency(0)}
          type="currency"
        />
        <p className="text-xs font-poppins text-greyscaleGON-400">
          note : minimal topup {currency(10000)}
        </p>
      </div>
      <div
        id="metode-pembayaran"
        className="w-full bg-primaryGON-50 p-2 text-center"
      >
        <p className="p2-medium text-greyscaleGON-700">
          Pilih Metode Pembayaran
        </p>
      </div>
      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-4">
          {Object.entries(listBank ?? {})
            ?.map(([_, item]) => ({ _, item }))
            ?.map((item, index) => {
              return (
                item?.item?.length > 0 && (
                  <div key={index} className="flex flex-col gap-4">
                    <div
                      onClick={() =>
                        setShowBank((old) => ({
                          ...old,
                          [index]: !showBank?.[index]
                        }))
                      }
                      className="cursor-pointer py-4 px-6 border-b border-b-greyscaleGON-200 rounded-md flex flex-row items-center justify-between"
                    >
                      <p className="subheading-medium text-greyscaleGON-700">
                        {item?._ == "VA"
                          ? "Virtual Account"
                          : item?._ == "WA"
                          ? "Wallet Account"
                          : "Other"}
                      </p>
                      <div>
                        {!showBank?.[index] ? (
                          <ChevronDownSvg className="w-8 h-8 text-greyscaleGON-400" />
                        ) : (
                          <ChevronUpSvg className="w-8 h-8 text-greyscaleGON-400" />
                        )}
                      </div>
                    </div>
                    {!showBank?.[index] ? null : (
                      <div className="flex flex-col gap-1">
                        {item?.item?.map((subItem, subIndex) => {
                          const myChoose =
                            chooseBank?.bank_code === subItem?.bank_code;
                          return (
                            <div
                              key={subIndex}
                              onClick={() =>
                                setChooseBank((old) =>
                                  myChoose
                                    ? {
                                        order_id: old?.order_id
                                      }
                                    : {
                                        ...subItem,
                                        order_id: old?.order_id
                                      }
                                )
                              }
                              className={
                                "cursor-pointer mx-6 py-2 gap-4 flex flex-row items-center rounded-md border-b border-b-greyscaleGON-200"
                              }
                            >
                              <div>
                                {myChoose ? (
                                  <RadioCheckedSvg className="w-4 h-4 text-primaryGON-400" />
                                ) : (
                                  <RadioUncheckSvg className="w-4 h-4 text-primaryGON-400" />
                                )}
                              </div>
                              <p className="subheading-regular text-greyscaleGON-700">
                                {subItem?.name}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )
              );
            })}
        </div>
        <div className="flex flex-col-reverse xs:flex-row w-full justify-between gap-4 items-center ">
          <Button
            id="btn-close-topup"
            label="Batalkan"
            variants="outline"
            disable={loading}
            onClick={closeModal}
            className="w-full"
          />
          <Button
            id="btn-handle-topup"
            label="Topup Sekarang"
            disable={loading}
            onClick={() => handleTopUp(chooseBank)}
            className="w-full"
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}
